import React, { useRef } from "react";
import { Drawer, Grid } from "antd";
import { useTheme } from "../../../../Styles/ThemeHook";
import { PropertyCardSkeleton } from "shared-components/Components/Property/PropertyCard/PropertyCardSkeleton";
import { ListingCard } from "shared-components/ViewFragments/SearchPage/ListingCard";
const { useBreakpoint } = Grid;

const K_INFOWINDOW_WIDTH = 250;
const K_INFOWINDOW_MARGIN_SIDES = 100;
const K_INFOWINDOW_MARGIN_TOP = 120;

const ListingInfoWindow = ({ show, listingId, position, onClose, property }) => {
	const { theme } = useTheme();
	const screen = useBreakpoint();

	const divRef = useRef(null);

	if (!show || listingId == 0) return null;

	let stylesPosition = {};
	if (position === "left") {
		stylesPosition = { left: K_INFOWINDOW_MARGIN_SIDES };
	} else if (position === "right") {
		stylesPosition = { right: K_INFOWINDOW_MARGIN_SIDES };
	}

	const infoWindowContent = (
		<ListingCard data={property} hideCta staticGallery />
	);

	if (!screen.lg)
		return (
			<Drawer
				closeIcon={null}
				bodyStyle={{ padding: theme.spacing.smSpacing }}
				onClose={onClose}
				visible={show}
				height={"auto"}
				placement={"bottom"}
				children={infoWindowContent}
				maskStyle={{ backgroundColor: "transparent" }}
				maskClosable
				footer={null}
			/>
		);

	return (
		<>
			<div
				className={"map-infowindow-container"}
				ref={divRef}
				style={{
					width: K_INFOWINDOW_WIDTH,
					position: "absolute",
					zIndex: 5,
					top: K_INFOWINDOW_MARGIN_TOP,
					...stylesPosition,
				}}>
				{infoWindowContent}
			</div>
		</>
	);
};

export {
	ListingInfoWindow,
	K_INFOWINDOW_WIDTH,
	K_INFOWINDOW_MARGIN_SIDES,
	K_INFOWINDOW_MARGIN_TOP,
};
